export const DS_F2W_Business_Travel_Team = 'DS_F2W_Business_Travel_Team';
export const DS_F2W_Edit = 'DS_F2W_Edit';
export const DS_F2W_HR_Team = 'DS_F2W_HR_Team';

export const VALID_LOGIN_F2W_ROLES = [DS_F2W_Business_Travel_Team, DS_F2W_Edit, DS_F2W_HR_Team];
